/**
 * Default favorite markers that will be shown when users have no favorites yet.
 * These are common health markers that most users would want to track.
 * Simply add or remove externalKey values to customize the default favorites.
 */
export const DEFAULT_FAVORITE_MARKER_KEYS: string[] = [
  'ActiveEnergyExpenditure',
  'Steps',
  'SleepHours',
  'SleepTimeDeep',
  'HRVAvgSleepRMSSD',
  'HRVAvgSleepSDNN'
];
